import React from 'react';

const GraphicDesign = () => {
  const designs = [
    {
      id: 1,
      title: 'Cool Flairs Money Bag',
      description: 'A creative cover art fot the Cool Flairs single titled "Money Bag.',
      image: '/images/graphic_design/moneyBag.jpeg',
      date: '2026-06-09',
    },
    {
      id: 2,
      title: 'Cosmetology Expo 2026',
      description: 'A design for Ministry Of Small and Medium Enterprise Development 2026 expo.',
      image: '/images/graphic_design/Expo2026.jpeg',
      date: '2026-07-12',
    },
    {
      id: 3,
      title: 'Ndise Tiliko',
      description: 'A creative cover art fot the Cool Flairs single titled "Ndise Tiliko.',
      image: '/images/graphic_design/Ndise.jpeg',
      date: '2026-07-13',
    },
    {
      id: 5,
      title: 'Apply, Submit',
      description: 'A design for Ecouncils advertisement.',
      image: '/images/graphic_design/ApplySubmit.jpeg',
      date: '2026-07-20',
    },
    {
      id: 6,
      title: 'All Services',
      description: 'A comprehensive design showcasing all the services offered on the Ecouncils platform, featuring a clean and modern layout.',
      image: '/images/graphic_design/AllServices.jpeg',
      date: '2026-07-20',
    },
    {
      id: 7,
      title: 'All Services',
      description: 'A comprehensive design showcasing all the services offered on the Ecouncils platform, featuring a clean and modern layout.',
      image: '/images/graphic_design/LifeIwannalive.jpeg',
      date: '2026-07-26',
    },
  ];

  return (
    <div className="graphic-design-page">
      <section className="section" style={{ paddingTop: '8rem', background: 'var(--bg-dark)' }}>
        <h2 className="section-title" style={{color: 'rgb(255, 255, 255)'}}>Graphic Design</h2>
        <p style={{ textAlign: 'center', color: 'rgba(255,255,255,0.7)', maxWidth: '600px', margin: '0 auto 3rem' }}>
          A collection of my graphic design work, including branding, layouts, and visual assets.
        </p>

        <div className="projects-grid" data-tour="design-grid">
          {designs.map((design, index) => (
            <div key={design.id} className={`project-card fade-in-up stagger-${index + 1}`}>
              <div className="project-image">
                <img src={design.image} alt={design.title} />
              </div>
              <div className="project-content">
                <h3>{design.title}</h3>
                <p>{design.description}</p>
                <span className="tech-tag" style={{ background: 'var(--primary)', color: '#fff' }}>
                  Uploaded: {design.date}
                </span>
              </div>
            </div>
          ))}
        </div>
        </section>
    </div>
  );
};

export default GraphicDesign;